import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "../Edit.css"; // Importar el archivo CSS compartido
import { useShoppingContext } from "../../../context/ShoppingContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faChevronRight,
  faChevronDown,
  faDove,
  faChevronLeft,
  faEdit,
} from "@fortawesome/free-solid-svg-icons";
import AddGalpon from "../../Add/Buttons/AddGalpon/AddGalpon";
import AddBatch from "../../Add/Buttons/AddBatch/AddBatch";

const EditGranja = () => {
  const { id } = useParams(); // Obtener el ID de la granja desde la URL
  const navigate = useNavigate();
  const {
    galpones,
    fetchMisGalpones,
    fetchMisGranjas,
    granjas,
    setGranjas,
    aves,
    fetchMisAves,
  } = useShoppingContext();

  const [formData, setFormData] = useState({
    nombre: "",
    ubicacion: "",
    userId: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [openGalpones, setOpenGalpones] = useState({}); // Estado para controlar qué galpones están desplegados

  useEffect(() => {
    fetchMisGranjas();
    fetchMisGalpones();
    fetchMisAves();
  }, [fetchMisGranjas, fetchMisGalpones, fetchMisAves]);

  useEffect(() => {
    const granja = granjas.find((granja) => granja.id === parseInt(id));
    if (granja) {
      setFormData({
        nombre: granja.nombre,
        ubicacion: granja.ubicacion,
        userId: granja.userId,
      });
    }
  }, [id, granjas]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading("Guardando Cambios");
      await axios.put(
        `${process.env.REACT_APP_API_URL}/granjas/${id}`,
        formData
      );
      setLoading(false);
    } catch (error) {
      setError("Error al actualizar la granja.");
      setLoading(false);
    }
  };

  const handleBack = () => {
    localStorage.setItem("granjaActiva", id); // Almacenar la granja activa en localStorage
    navigate(-1); // Volver a la página del carousel
  };

  const toggleGalpon = (galponId) => {
    setOpenGalpones((prevOpenGalpones) => ({
      ...prevOpenGalpones,
      [galponId]: !prevOpenGalpones[galponId], // Alternar el estado desplegado de cada galpón
    }));
  };

  // Eliminar Galpón por ID
  const handleDeleteGalpon = async (galponId, nombre) => {
    if (
      window.confirm(
        `¿Estás seguro de que quieres eliminar el galpón "${nombre}"?`
      )
    ) {
      try {
        await axios.delete(
          `${process.env.REACT_APP_API_URL}/galpones/${galponId}`
        );
        fetchMisGalpones(); // Actualizar la lista de galpones después de eliminar
      } catch (error) {
        console.error("Error al eliminar el galpón:", error);
        setError(
          error.response?.data?.message || "Error al eliminar el galpón"
        );
      }
    }
  };

  // Eliminar Ave por ID
  const handleDeleteAve = async (aveId, nombre) => {
    if (
      window.confirm(
        `¿Estás seguro de que quieres eliminar el ave "${nombre}"?`
      )
    ) {
      try {
        await axios.delete(`${process.env.REACT_APP_API_URL}/aves/${aveId}`);
        fetchMisAves(); // Actualizar la lista de aves después de eliminar
      } catch (error) {
        console.error("Error al eliminar el ave:", error);
        setError(error.response?.data?.message || "Error al eliminar el ave");
      }
    }
  };

  const handleDeleteGranja = async (granjaId, nombre) => {
    if (
      window.confirm(
        `¿Estás seguro de que quieres eliminar la granja "${nombre}" junto con todos sus registros?`
      )
    ) {
      try {
        await axios.delete(
          `${process.env.REACT_APP_API_URL}/granjas/${granjaId}`
        );
        setGranjas(granjas.filter((granja) => granja.id !== granjaId));
        navigate("/mis-granjas");
      } catch (error) {
        console.error("Error al eliminar la granja:", error);
        setError(
          error.response?.data?.message || "Error al eliminar la granja"
        );
      }
    }
  };

  return (
    <div className="edit-container">
      <button className="btn btn-back" onClick={handleBack}>
        <FontAwesomeIcon icon={faChevronLeft} /> Volver
      </button>
      {error && <p className="error-message">{error}</p>}

      {loading ? (
        <p>Cargando...</p>
      ) : (
        <>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="nombre">Nombre de la Granja</label>
              <input
                type="text"
                id="nombre"
                name="nombre"
                value={formData.nombre}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="ubicacion">Ubicación</label>
              <input
                type="text"
                id="ubicacion"
                name="ubicacion"
                value={formData.ubicacion}
                onChange={handleChange}
                required
              />
            </div>

            <button type="submit" className="btn btn-primary">
              Guardar Cambios
            </button>

            <div className="">
              <div className="edit-buttons">
                <AddGalpon />
                <AddBatch />
              </div>
              <h3>Galpones y Aves</h3>
              {galpones.length > 0 ? (
                <ul className="galpones-list">
                  {galpones
                    .filter((galpon) => galpon.granjaId === parseInt(id))
                    .map((galpon) => (
                      <li key={galpon.id} className="galpon-item">
                        <div
                          className="galpon-header"
                          onClick={() => toggleGalpon(galpon.id)}
                        >
                          <div>
                            <FontAwesomeIcon className="dove" icon={faDove} />
                            <FontAwesomeIcon
                              className="galpon-header-icon"
                              icon={
                                openGalpones[galpon.id]
                                  ? faChevronDown
                                  : faChevronRight
                              }
                            />
                            <strong>{galpon.nombre}</strong>
                          </div>
                          <div>
                            <FontAwesomeIcon
                              icon={faEdit}
                              onClick={() =>
                                navigate(`/edit-galpon/${galpon.id}`)
                              }
                            />
                            <button
                              className="delete-button"
                              onClick={() =>
                                handleDeleteGalpon(galpon.id, galpon.nombre)
                              }
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </div>
                        </div>

                        {openGalpones[galpon.id] && (
                          <ul className="aves-list">
                            {aves
                              .filter((ave) => ave.galponId === galpon.id)
                              .map((ave) => (
                                <li key={ave.id} className="ave-item">
                                  <div>
                                    <strong>{ave.nombre}</strong>
                                    <p className="ave-data">
                                      Saldo: {ave.saldo} aves - Edad:{" "}
                                      {ave.edad_actual} semanas
                                    </p>
                                  </div>
                                  <div>
                                    <FontAwesomeIcon
                                      icon={faEdit}
                                      onClick={() =>
                                        navigate(`/edit-ave/${ave.id}`)
                                      }
                                    />
                                    <button
                                      className="delete-button"
                                      onClick={() =>
                                        handleDeleteAve(ave.id, ave.nombre)
                                      }
                                    >
                                      <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                  </div>
                                </li>
                              ))}
                          </ul>
                        )}
                      </li>
                    ))}
                </ul>
              ) : (
                <p>No hay galpones registrados en esta granja.</p>
              )}
            </div>

            <div
              className="btn btn-red-outline"
              onClick={() => handleDeleteGranja(id, formData.nombre)}
            >
              Eliminar Granja y todos sus registros{" "}
              <FontAwesomeIcon icon={faTrash} />
            </div>
          </form>
        </>
      )}
    </div>
  );
};

export default EditGranja;
